<template>
  <view-container>
    <v-card>
      <v-card-text>
        <v-form v-model="valid">
          <reference-field
            v-if="!user.clientId"
            v-model="item.clientId"
            :rules="rules.clientId"
            :disabled="!!item.clientId"
            reference="client"
            label="Клиент"
          />
          <v-text-field
            v-model="item.product.name"
            :rules="rules['product.name']"
            label="Название"
          />
          <v-container class="pa-0" fluid>
            <v-row>
              <v-col cols="6" md="3">
                <currency-field
                  v-model="item.product.price"
                  label="Цена за единицу"
                />
              </v-col>
              <v-col cols="6" md="3">
                <quantity-field
                  v-model="item.product.quantity"
                  label="Количество"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  :items="taxTypes"
                  item-text="name"
                  item-value="id"
                  clearable
                  v-model="item.product.taxType"
                  label="Ставка НДС"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  :items="productTypes"
                  item-text="name"
                  item-value="id"
                  clearable
                  v-model="item.product.productType"
                  label="Тип предмета расчета"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  :items="paymentMethods"
                  item-text="name"
                  item-value="id"
                  clearable
                  v-model="item.product.paymentMethod"
                  label="Способ расчета"
                />
              </v-col>
            </v-row>
          </v-container>
          <v-text-field
            v-model="item.product.productId"
            label="Внутренний идентификатор товара (при наличии)"
          />
          <reference-field
            v-model="item.itemGroupId"
            :rules="rules.itemGroupId"
            reference="itemGroup"
            label="Номенклатурная группа (опционально)"
            :disabled="!item.clientId && !user.clientId"
            :filter="itemGroupFilter"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="save" :disabled="!valid">{{
          item.id ? "Сохранить" : "Создать"
        }}</v-btn>
        <v-btn text @click="cancel">Отмена</v-btn>
        <v-spacer />
        <confirmation-dialog
          v-if="item.id"
          @confirm="onDelete"
          title="Удалить безвозвратно?"
          text="Удаление товарной позиции не повлияет на уже созданые чеки и заказы."
          color="red"
        >
          <template #activator="{ on }">
            <v-btn color="red" text dark v-on="on">Удалить</v-btn>
          </template>
        </confirmation-dialog>
      </v-card-actions>
    </v-card>
  </view-container>
</template>
<script>
import ds from "@/datastore";
import { TaxTypes, ProductTypes, PaymentMethods } from "@/datastore/enums";
export default {
  name: "ItemEdit",
  props: {
    id: String,
    clientId: String
  },
  data() {
    return {
      dialog: false,
      item: ds.createRecord(
        "item",
        {
          clientId: this.clientId,
          product: {
            paymentMethod: 4
          }
        },
        { noValidate: true }
      ),
      taxTypes: TaxTypes,
      productTypes: ProductTypes,
      paymentMethods: PaymentMethods,
      valid: false
    };
  },
  async created() {
    if (this.id) {
      let item = await ds.find("item", this.id);
      this.item = ds.createRecord("item", item.toJSON(), { noValidate: true });
      this.$store.commit(
        "setTitle",
        "Номенклатурная позиция " + this.item.product.name
      );
    } else if (this.user.clientId) {
      this.item.clientId = this.user.clientId;
    }
  },
  computed: {
    user() {
      return this.$store.getters["auth/getUser"];
    },
    rules() {
      return this.item.$rules || {};
    },
    itemGroupFilter() {
      return { clientId: this.item.clientId };
    }
  },
  methods: {
    async save() {
      let item = await this.item.save();
      this.$store.commit("notifications/success", "Позиция сохранена");
      this.cancel();
      return item;
    },
    async onDelete() {
      await this.item.destroy();
      this.$store.commit("notifications/success", "Позиция удалена");
      this.cancel();
    },
    cancel() {
      this.$destroy();
      this.$router.go(-1);
    }
  }
};
</script>
